import React from 'react';
import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    EmailShareButton,
    WhatsappShareButton,
} from 'react-share';

import './SocialSharing.scss';

import { FaFacebook, FaLinkedin, FaWhatsapp, FaTwitter } from 'react-icons/fa';
import { HiOutlineMail } from 'react-icons/hi';
import { HasWindow } from '@helpers/GlobalHelpers';

SocialSharing.defaultProps = {
    theme: 'dark',
    align: 'center',
    size: 'l',
};

// DO IT IN TS.
export default function SocialSharing(props) {
    const isWindow = HasWindow();

    let mod_class = [
        'SocialSharing',
        props.align !== undefined ? 'align-' + props.align : '',
        props.size !== undefined ? 'size-' + props.size : '',
        props.theme !== undefined ? 'theme-' + props.theme : '',
    ];
    mod_class = mod_class.join(' ');

    function getTitle() {
        if (props.title) return props.title;
        if (document) return document.title;
        return '';
    }

    function getURL() {
        if (props.url) return props.url + '?utm_source=share';
        if (window) return window.location.href + '?utm_source=share';
        return '';
    }

    function getHastags() {
        return 'aepsy';
    }

    function getSummary() {
        if (props.summary) return props.summary;
        if (document) return document.description;
        return '';
    }

    if (isWindow) {
        return (
            <div className={mod_class}>
                <ul>
                    {/* Facebook */}
                    <li className="SocialSharing--list">
                        <FacebookShareButton
                            url={getURL()}
                            quote={getTitle()}
                            separator=" - "
                            hashtag={getHastags()}
                        >
                            <span className="SocialSharing--icon">
                                <FaFacebook />
                            </span>
                        </FacebookShareButton>
                    </li>

                    {/* Whatsapp */}
                    <li className="SocialSharing--list">
                        <WhatsappShareButton
                            url={getURL()}
                            title={getTitle()}
                            separator=" - "
                        >
                            <span className="SocialSharing--icon">
                                <FaWhatsapp />
                            </span>
                        </WhatsappShareButton>
                    </li>

                    {/* Linkedin */}
                    <li className="SocialSharing--list">
                        <LinkedinShareButton
                            url={getURL()}
                            title={getTitle()}
                            summary={getSummary()}
                        >
                            <span className="SocialSharing--icon">
                                <FaLinkedin />
                            </span>
                        </LinkedinShareButton>
                    </li>

                    {/* Twitter */}
                    <li className="SocialSharing--list">
                        <TwitterShareButton
                            url={getURL()}
                            title={getTitle()}
                            separator=" - "
                            hashtag={getHastags()}
                        >
                            <span className="SocialSharing--icon">
                                <FaTwitter />
                            </span>
                        </TwitterShareButton>
                    </li>

                    {/* Mail */}
                    <li className="SocialSharing--list">
                        <EmailShareButton url={getURL()} subject={getTitle()}>
                            <span className="SocialSharing--icon">
                                <HiOutlineMail />
                            </span>
                        </EmailShareButton>
                    </li>
                </ul>
            </div>
        );
    } else {
        return '';
    }
}
